import { render } from "./OrgAllTeams.vue?vue&type=template&id=4eb8b6da&scoped=true"
import script from "./OrgAllTeams.vue?vue&type=script&lang=js"
export * from "./OrgAllTeams.vue?vue&type=script&lang=js"

import "./OrgAllTeams.vue?vue&type=style&index=0&id=4eb8b6da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb8b6da"]])

export default __exports__